import { FolderContent } from '@/api/generatedApi';
import { getAssetFileName, isAsset } from '@/utils/assets';
import { ROOT_FOLDER_ID, isFolder } from '@/utils/folders';

export interface ContentMoveState {
  content: FolderContent;
  originalParentId: string | undefined;
  status: 'pending' | 'processing' | 'success' | 'error';
  error?: string;
}

export const toApiFolderId = (folderId: string | undefined): string | null => folderId ?? ROOT_FOLDER_ID;

export const getContentName = (content: FolderContent): string => {
  if (isFolder(content)) {
    return content.name;
  }
  if (isAsset(content)) {
    return getAssetFileName(content);
  }
  return '';
};

export const getContentOriginalParentId = (content: FolderContent): string | undefined => {
  if (isFolder(content)) {
    return content.parentFolderId ?? undefined;
  }
  if (isAsset(content)) {
    return content.folderId ?? undefined;
  }
  return undefined;
};
